import React, {FC} from "react"
import {Modal} from "react-bootstrap"
import {isEmpty, get} from "lodash"
import {CodeContext} from "@irati/deals/context"

import withBranding, {WithBranding} from "@irati/brand/withBranding"
import Expand from "@irati/ui/src/Expander"
import {Label} from "@irati/ui/src/Typography"
import {determineDealThumbnailImage} from "@irati/deals/helpers/deals/appearance"
import {CheckoutRedemption} from "@irati/types"
import {injectIntl, InjectIntl, FormattedMessage} from "@irati/utils/lang"

import {getVouchersFromRedemption} from "../../helpers/redemption/getVouchersFromRedemption"
import TicketRepeater from "../Tickets/TicketRepeater"
import BirthdayBoxTicket from "../Tickets/Ticket/BirthdayBoxTicket"
import TicketInstructions from "../Tickets/TicketInstructions"
import Terms from "../Tickets/Terms"
import TicketTop from "../Tickets/TicketTop"
import TicketBottom from "../Tickets/TicketBottom"
import DownloadPdf from "../Tickets/DownloadPdf"
import "./styled/styles.css"

import {shouldDisplayDealAvatar} from "../../utils/deals/imageUtils"
import {DealAvatar, InstructionHeader, PopupHeader, StyledClose} from "./styled/PerkSummaryPopup"

interface Props extends InjectIntl, WithBranding {
  show: boolean,
  onHide: () => void,
  redemption: CheckoutRedemption
}

const PerkSummaryPopup: FC<Props> = ({redemption, show, onHide, formatMessage, branding}) => {
  const {header, redemptionInstructions} = redemption.dealSnapshot
  const isBirthdayBox = redemption?.dealSnapshot?.isBirthdayBox
  const vouchers = get(redemption, "order", null) ? getVouchersFromRedemption(redemption) : []
  const pdf = get(redemption, "pdf")
  const thumbnailImage = shouldDisplayDealAvatar(redemption.dealSnapshot) ?
    determineDealThumbnailImage(redemption.dealSnapshot, branding) : null

  return (
    <Modal show={show} onHide={onHide} dialogClassName="myPerksTicket-dialog">
      <StyledClose top="40px" right="20px" onClick={onHide} />
      <TicketTop>
        <div className="center">
          {thumbnailImage && <DealAvatar src={thumbnailImage} alt={header} marginTop={-20} large withShadow />}
          <PopupHeader>{header}</PopupHeader>
          <InstructionHeader>
            <FormattedMessage id="perks.components.myPerks.perkSummaryPopup.upperText" />
            <br />
            <FormattedMessage id="perks.components.myPerks.perkSummaryPopup.lowerText" />
          </InstructionHeader>
        </div>
        {!isEmpty(vouchers) && (
          <div className="center">
            <Expand
              hideText={formatMessage({id: "perks.components.myPerks.perkSummaryPopup.expand.hide"})}
              showText={formatMessage({id: "perks.components.myPerks.perkSummaryPopup.expand.show"})}
              HeaderLabel={Label}>
              <TicketInstructions item={redemption.dealSnapshot} instructions={redemptionInstructions} />
            </Expand>
          </div>
        )}
        {isEmpty(vouchers) && <TicketInstructions item={redemption.dealSnapshot} instructions={redemptionInstructions} />}
        <DownloadPdf pdf={pdf} className="center" />
      </TicketTop>
      {!isEmpty(vouchers) && isBirthdayBox && <BirthdayBoxTicket vouchers={vouchers} />}
      {!isEmpty(vouchers) && !isBirthdayBox && (
        <CodeContext.Provider value={{shouldAutoOpenLink: false}}>
          <TicketRepeater redemptionId={redemption.uuid} vouchers={vouchers} externalLinks={redemption.dealSnapshot?.externalLinks} />
        </CodeContext.Provider>
      )}
      <TicketBottom>
        <Terms />
      </TicketBottom>
    </Modal>
  )
}


export default injectIntl(withBranding(PerkSummaryPopup))
